import { Loading } from "../../loading";
import { TableSkeleton } from "../../skeleton";
import { ErrorState, ForbiddenState } from "../../state-message";
import { useHubTableContext } from "../hub-table.context";
import styles from "../hub-table.module.scss";
import { HubTableEmptyDefault } from "./view-empty-default";

/** Estados sem a tabela (acesso negado, erro, carregamento inicial, vazio `replace` e carregamento que sai do vazio): o da tela ou o padrão. */
export function HubTableState() {
  const {
    view,
    slots,
    errorMessage,
    onRetry,
    table,
    visibleColumnCount,
    size,
    isLoading,
    loadingLabel,
    partTestId,
  } = useHubTableContext();

  if (view === "forbidden") {
    return (
      slots.forbidden ?? (
        <ForbiddenState description={errorMessage} testId={partTestId("forbidden")} />
      )
    );
  }
  if (view === "error") {
    return (
      slots.error ?? (
        <ErrorState description={errorMessage} onRetry={onRetry} testId={partTestId("error")} />
      )
    );
  }
  if (view === "loading") {
    return (
      slots.loading ?? (
        <TableSkeleton
          rows={table.rows}
          columns={visibleColumnCount}
          size={size}
          testId={partTestId("loading")}
        />
      )
    );
  }
  if (isLoading) {
    return (
      <div className={styles.loadingCenter}>
        <Loading label={loadingLabel} testId={partTestId("loading")} />
      </div>
    );
  }
  return slots.empty ?? <HubTableEmptyDefault />;
}
HubTableState.displayName = "HubTable.State";
